import { Component, OnInit } from '@angular/core';

interface EventItem {
  title: string;
  description: string;
  icon: string;
  date: string;
}

interface AcademicYear {
  year: string;
  events: EventItem[];
}

@Component({
  selector: 'app-latest-in-college',
  templateUrl: './latest-in-college.component.html',
  styleUrls: ['./latest-in-college.component.scss']
})
export class LatestInCollegeComponent implements OnInit {

  academicYears: AcademicYear[] = [
    {
      year: '2024-2025',
      events: [
        {
          title: 'Fresher Party',
          description: 'A grand welcome celebration organized to welcome and integrate the incoming batch of undergraduate and postgraduate students. The event features cultural dance, musical performances, and talent showcases, fostering peer bonding and community spirit.',
          icon: 'fa-gift',
          date: 'September 2024'
        },
        {
          title: 'Induction Program',
          description: 'A comprehensive orientation session designed to introduce new students to the academic structures, campus facilities, code of conduct, and the unique spiritual and moral values of Shah Satnam Ji Girls\' College.',
          icon: 'fa-landmark',
          date: 'August 2024'
        },
        {
          title: 'Teacher\'s Day',
          description: 'A heartfelt celebratory event organized by the students to honor and express gratitude to the dedicated faculty members who guide them towards excellence in both academics and life.',
          icon: 'fa-chalkboard-user',
          date: 'September 5, 2024'
        }
      ]
    },
    {
      year: '2023-2024',
      events: [
        {
          title: 'Annual Athletic Meet',
          description: 'Students showcased remarkable sportsmanship and athletic prowess in various track and field events, in line with the college\'s strong legacy of producing national and international champions.',
          icon: 'fa-trophy',
          date: 'February 2024'
        },
        {
          title: 'National Seminar on Digital Empowerment',
          description: 'A high-profile academic seminar bringing together industry experts and scholars to discuss digital innovation, research methods, and career prospects in emerging tech domains.',
          icon: 'fa-laptop-code',
          date: 'November 2023'
        }
      ]
    }
  ];

  selectedYear: AcademicYear = this.academicYears[0];

  constructor() { }

  ngOnInit(): void {
    this.selectedYear = this.academicYears[0];
  }

  selectYear(year: AcademicYear): void {
    this.selectedYear = year;
  }

}

